export default "./images/WD40.jpg";